import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer id="footer" className="footer position-relative bg-dark text-light pt-5">

        <div className="container">
          <div className="row">

            {/* Left Column */}
            <div className="col-lg-5 mb-4">
              <NavLink to="/" className="d-flex align-items-center mb-4 text-decoration-none">
                <span className="h4 text-white mb-0">Clinic</span>
              </NavLink>

              <p className="text-muted">
                Crafting exceptional digital experiences through thoughtful design
                and innovative solutions that elevate your brand presence.
              </p>

              <div className="mt-4">
                <p><i className="bi bi-geo-alt me-2"></i>123 Creative Boulevard, Design District, NY 10012</p>
                <p><i className="bi bi-telephone me-2"></i>+1 (555) 987-6543</p>
                <p><i className="bi bi-envelope me-2"></i>hello@designstudio.com</p>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-7">
              <div className="row">

                <div className="col-6 col-lg-3 mb-4">
                  <h6 className="text-white">Studio</h6>
                  <ul className="list-unstyled">
                    <li><a href="#!" className="text-decoration-none">Our Story</a></li>
                    <li><a href="#!" className="text-decoration-none">Design Process</a></li>
                    <li><a href="#!" className="text-decoration-none">Portfolio</a></li>
                    <li><a href="#!" className="text-decoration-none">Case Studies</a></li>
                    <li><a href="#!" className="text-decoration-none">Awards</a></li>
                  </ul>
                </div>

                <div className="col-6 col-lg-3 mb-4">
                  <h6 className="text-white">Services</h6>
                  <ul className="list-unstyled">
                    <li><a href="#!" className="text-decoration-none">Brand Identity</a></li>
                    <li><a href="#!" className="text-decoration-none">Web Design</a></li>
                    <li><a href="#!" className="text-decoration-none">Mobile Apps</a></li>
                    <li><a href="#!" className="text-decoration-none">Digital Strategy</a></li>
                    <li><a href="#!" className="text-decoration-none">Consultation</a></li>
                  </ul>
                </div>

                <div className="col-6 col-lg-3 mb-4">
                  <h6 className="text-white">Resources</h6>
                  <ul className="list-unstyled">
                    <li><a href="#!" className="text-decoration-none">Design Blog</a></li>
                    <li><a href="#!" className="text-decoration-none">Style Guide</a></li>
                    <li><a href="#!" className="text-decoration-none">Free Assets</a></li>
                    <li><a href="#!" className="text-decoration-none">Tutorials</a></li>
                    <li><a href="#!" className="text-decoration-none">Inspiration</a></li>
                  </ul>
                </div>

                <div className="col-6 col-lg-3 mb-4">
                  <h6 className="text-white">Connect</h6>
                  <ul className="list-unstyled">
                    <li><a href="#!" className="text-decoration-none">Start Project</a></li>
                    <li><a href="#!" className="text-decoration-none">Schedule Call</a></li>
                    <li><a href="#!" className="text-decoration-none">Join Newsletter</a></li>
                    <li><a href="#!" className="text-decoration-none">Follow Updates</a></li>
                    <li><a href="#!" className="text-decoration-none">Partnership</a></li>
                  </ul>
                </div>

              </div>
            </div>

          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-top border-secondary mt-4 py-3">
          <div className="container">
            <div className="row align-items-center">

              <div className="col-lg-6 text-center text-lg-start mb-2 mb-lg-0">
                © <span className="text-white">Clinic</span>. All rights reserved.
              </div>

              <div className="col-lg-6 text-center text-lg-end">
                <a href="#!" className="text-muted me-3 text-decoration-none">Privacy Policy</a>
                <a href="#!" className="text-muted me-3 text-decoration-none">Terms of Service</a>
                <a href="#!" className="text-muted text-decoration-none">Cookie Policy</a>
              </div>

            </div>
          </div>
        </div>

      </footer>
    </>
  );
}

export default Footer;